export function toggleInnovationDetailsField() {
  var innovationDetailsField = $('#innovation-details');
  if ($(this).is(':checked')) {
    innovationDetailsField.removeClass('d-none');
  } else if ($(this).is(':not(:checked)')) {
    innovationDetailsField.addClass('d-none');
    $('#funding_application_economic_model_attributes_innovation_details').val('');
  }
}
